module.exports = __webpack_public_path__ + "../../dist/v1/media/oidnv_kampagnenfilm.webm";